import React, { Component } from 'react'
import Slider from 'react-slick'

import './BackgroundFade.css'

import img1 from '../assets/slider/levain_bg_img_1.jpg'
import img2 from '../assets/slider/levain_bg_img_2.jpg'
import img3 from '../assets/slider/levain_bg_img_3.jpg'
import img4 from '../assets/slider/levain_bg_img_4.jpg'
import img5 from '../assets/slider/levain_bg_img_5.jpg'
import img6 from '../assets/slider/levain_bg_img_6.jpg'

export default class BackgroundFade extends Component {
  constructor(props) {
    super(props)
    this.next = this.next.bind(this)
  }

  next() {
    this.slider.slickNext()
  }

  render() {
    let settings = {
      arrows: false,
      autoplay: true,
      autoplaySpeed: 6000,
      dots: false,
      draggable: false,
      touchMove: false,
      swipe: false,
      fade: true,
      infinite: true,
      lazyLoad: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 3000,
    }

    setTimeout(() => {
      this.next()
    }, 5000)

    return (
      <Slider ref={c => this.slider = c } {...settings}>
        <div><div style={{backgroundImage: 'url('+img1+')'}} /></div>
        <div><div style={{backgroundImage: 'url('+img2+')'}} /></div>
        <div><div style={{backgroundImage: 'url('+img3+')'}} /></div>
        <div><div style={{backgroundImage: 'url('+img4+')'}} /></div>
        <div><div style={{backgroundImage: 'url('+img5+')'}} /></div>
        <div><div style={{backgroundImage: 'url('+img6+')'}} /></div>
      </Slider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BackgroundFade.js